<script>
import App from "@/pages/layouts/app.vue";
import Form from '@/pages/tags/_form.vue';
import UpdateForm from "@wielink-application/shared/js/mixins/updateForm";

export default {
  mixins: [UpdateForm],
  components: {App, Form},
  props: ['tag_id'],
  data() {
    return {
      formRoute: route('api.v1.knowledge_base.tags.update', {tag: this.tag_id}),
      redirectRoute: route('knowledge_base.tags.index'),
    }
  },
  methods: {
    afterSuccess(form, response) {
      this.getTag();
    },

    getTag() {
      this.loading = true;
      $.ajax({
        url: route('api.v1.knowledge_base.tags.show', {'tag': this.tag_id}),
        success: (response) => {
          this.$refs.form.setTag(response.data);
        }
      }).always(() => {
        this.loading = false;
      })
    }
  },
  mounted() {
    this.getTag();
  }
}
</script>

<template>
  <App title="Label bewerken">
    <form id="tagForm" @submit.prevent="submit">
      <Form ref="form"/>
    </form>

    <template #bottomButtons>
      <FormButtons
          @backToOverview="stayOnPage = 0"
          :loading="loading"
          form-id="tagForm"
          :cancel-route="redirectRoute"
      />
    </template>
  </App>
</template>